import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFilm, 
    faFutbol, 
    faGamepad, 
    faCalendarDay, 
    faMapSigns, 
    faVideo, 
    faListAlt, 
    faGift, 
    faTags, 
    faClipboardList 
} from '@fortawesome/free-solid-svg-icons';

import './ThinkTicket.css';
import thinkticketimage from '../../assets/pageimages/ThinkTicket.webp';

function ThinkTicketHome() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-pink-300 via-red-500 to-purple-600 flex flex-col items-center py-8">
        <h2 className="text-4xl font-bold text-white text-center mb-4">ThinkTicket</h2>
        <img
          src={thinkticketimage}
          alt="ThinkTravel"
          style={{width:'300px', height: 'auto'}}
          className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md"
        />

        <div className="flex-grow">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkNoButton to="" icon={faFilm} label="Movie" />               
            <LinkNoButton to="" icon={faFutbol} label="Sports" />             
            <LinkNoButton to="" icon={faGamepad} label="Play" />              
            <LinkNoButton to="" icon={faCalendarDay} label="Events" />        
            <LinkNoButton to="" icon={faMapSigns} label="Activities" />      
            <LinkNoButton to="" icon={faVideo} label="Stream" />              
            <LinkNoButton to="" icon={faListAlt} label="List Your Show" />    
            <LinkNoButton to="" icon={faGift} label="Gift" />                 
            <LinkNoButton to="" icon={faTags} label="Offers" />              
            <LinkNoButton to="" icon={faClipboardList} label="My Bookings" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkTicketHome;
